import isEmpty from "lodash/isEmpty.js"

const BASE_URL_V2 = process.env.BASE_URL_V2

export const state = () => ({
  gptSettigns: null,
})

export const mutations = {
  SAVE_GPT_SETTINGS(state, payload) {
    state.gptSettigns = payload
  },
}

export const actions = {
  async makeGptList({}, payload) {
    return this.$axios.$post(`${BASE_URL_V2}/gpt/make_list/`, payload)
  },
  async makeTextDraftModule({}, payload) {
    return this.$axios.$post(`${BASE_URL_V2}/gpt/text_draft/`, payload)
  },
  async getGptSettings({ state, commit }) {
    if (isEmpty(state.gptSettigns)) {
      const response = await this.$axios.$get(`${BASE_URL_V2}/gpt/make_list/constans/`)

      if(response){
        commit('SAVE_GPT_SETTINGS', response )
        return response
      }

      return null
    }

    return state.gptSettigns
  },
}

export const getters = {
  getGptSettings: (state) => {
    return state.gptSettigns
  },
}
